import { 
  FilePlus, 
  FileText, 
  FileClock, 
  FileCheck, 
  Files, 
  Home,
  Gavel,
  BarChart3,
  TrendingUp,
  Newspaper,
  Building2,
  FileSignature,
  FolderArchive,
  Users,
  LayoutTemplate,
} from "lucide-react";

export type NavItem = {
  name: string;
  path: string;
  icon: React.ElementType;
};

// Top-level navigation items
export const topNavItems: NavItem[] = [
  {
    name: "Home",
    path: "/dashboard",
    icon: Home,
  },
];

// Proposals section items - reordered per requirements
export const proposalNavItems: NavItem[] = [
  {
    name: "New RFP/Instruction",
    path: "/new",
    icon: FilePlus,
  },
  {
    name: "QuickQuote",
    path: "/reverse-auction",
    icon: Gavel,
  },
  {
    name: "Live Auctions",
    path: "/auctions",
    icon: FileClock,
  },
  {
    name: "Active",
    path: "/active",
    icon: FileText,
  },
  {
    name: "Completed",
    path: "/complete",
    icon: FileCheck,
  },
  {
    name: "Templates",
    path: "/templates",
    icon: LayoutTemplate,
  },
  {
    name: "All",
    path: "/all",
    icon: Files,
  },
];

// Knowledge navigation items
export const knowledgeNavItems: NavItem[] = [
  {
    name: "Knowledge Overview",
    path: "/knowledge",
    icon: BarChart3,
  },
  {
    name: "MyAnalytics",
    path: "/knowledge/my-analytics",
    icon: TrendingUp,
  },
  {
    name: "Teamwise Analytics",
    path: "/knowledge/teamwise",
    icon: BarChart3,
  },
  {
    name: "Legal Industry Intel",
    path: "/knowledge/legal-intel",
    icon: Newspaper,
  },
];

// NEW: My Firm section items
export const myFirmNavItems: NavItem[] = [
  {
    name: "Engagement Letter",
    path: "/firm/engagements",
    icon: FileSignature,
  },
  {
    name: "Document Repository",
    path: "/firm/documents",
    icon: FolderArchive,
  },
  {
    name: "Manage Panel",
    path: "/firm/panel",
    icon: Users,
  },
];

// Section definitions for the sidebar
export const sidebarSections = [
  {
    name: "Requests",
    icon: FileText,
    items: proposalNavItems,
  },
  {
    name: "Knowledge",
    icon: BarChart3,
    items: knowledgeNavItems,
  },
  {
    name: "My Firm",
    icon: Building2,
    items: myFirmNavItems,
  },
];
